import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { getMessaging, onMessage } from 'firebase/messaging';
import { onBackgroundMessage } from 'firebase/messaging/sw';
import { ChatService } from 'src/app/_services/chat_service';
import { RoutingService } from 'src/app/_services/routing.service';
import { NotificationAlertComponent } from '../notification-alert/notification-alert.component';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  isOpen: boolean = false;
  page: number = 1;
  count: number = 5;
  showLoader: boolean = false;
  notificaitons: any[] = [];
  showSeeMore: boolean = true;
  unReadCount:any;
  constructor(
    private chatManagement: ChatService,
    public routing: RoutingService,
    private dialogRef: MatDialog,
  ) {}

  async ngOnInit() {
    this.getUnReadNotificationsCount();
    this.listenForegroundMessages();
  }

  openDeclinedPopup(data:any) {
    const dialogRef = this.dialogRef.open(NotificationAlertComponent, {
      panelClass: 'ReasonDeclined',
      hasBackdrop: true,
      data: { bookingInfo: data},
    });
    dialogRef.afterClosed().subscribe((res: any) => {
    });
  }

  listenForegroundMessages() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      this.getUnReadNotificationsCount();
      this.openDeclinedPopup(payload.notification);
    });
    onBackgroundMessage(messaging, (payload2: any) => {
      this.getUnReadNotificationsCount();
    });
  }



  openDrop() {
    this.isOpen = !this.isOpen;
    this.unReadCount = 0;
    if(this.isOpen){
      this.getNotifications();
    }else{
      this.removeNotifications();
    }
  }

  seeMore() {
    this.page = this.page + 1;
    this.getNotifications();
  }

  removeNotifications(){
    this.notificaitons = [];
    this.page = 1;
  }

  getNotifications() {
    this.showLoader = true;
    let query = `?page=${this.page}&count=${this.count}`;
    this.chatManagement.getNotifications(query).subscribe({
      next: (response: any) => {
        if (response && response.isSuccess) {
          if (!response.data.length) {
            this.showSeeMore = false;
          }
          this.notificaitons = [...this.notificaitons, ...response.data];
        }
        this.showLoader = false;
      },
      error: (errorResponse: any) => {
        this.showLoader = false;
      },
    });
  }

  getUnReadNotificationsCount(){
    this.showLoader = true;
    this.chatManagement.getUnReadNotifications().subscribe({
      next: (response: any) => {
        if (response && response.isSuccess) {
          this.unReadCount = response.data.count;
        }
        this.showLoader = false;
      },
      error: (errorResponse: any) => {
        this.showLoader = false;
      },
    });
  }

  goToDetail(item: any) {
    if (item.notificationType === 'booking') {
      this.isOpen = false;
      this.goToBookingDetail(item.data.entityId);
    } else if (item.notificationType === 'refund') {
      this.isOpen = false;
      this.goToDetailRefundManagement(item.data.entityId);
    } else if (item.notificationType === 'service') {
      this.isOpen = false;
      this.goToDetailService(item.data.entityId);
    } else if (item.notificationType === 'location') {
      this.isOpen = false;
      this.goToDetailLocation(item.data.entityId);
    } else if (item.notificationType === 'complaint') {
      this.isOpen = false;
      this.goToDetailComplaints(item.data.entityId);
    } else if (item.notificationType === 'comboPackage') {
      this.isOpen = false;
      this.goToDetailComboPackage(item.data.entityId);
    } else if (item.notificationType === 'comboBooking') {
      this.isOpen = false;
      this.goToDetailComboBooking(item.data.entityId);
    }
  }

  goToBookingDetail(id: string) {
    const data: any = {
      bookingId: id,
    };
    this.routing.goToBookingDetail(data);
  }

  goToDetailRefundManagement(id: string) {
    const data: any = {
      refundManagementId: id,
    };
    this.routing.goToDetailRefundManagement(data);
  }

  goToDetailService(id: string) {
    const data: any = {
      serviceId: id,
    };
    this.routing.goToDetailService(data);
  }

  goToDetailLocation(id: string) {
    const data: any = {
      LocationId: id,
    };
    this.routing.goToDetailLocation(data);
  }

  goToDetailComplaints(id: string) {
    const data: any = {
      complaintId: id,
    };
    this.routing.goToDetailComplaints(data);
  }

  goToDetailComboPackage(id: string) {
    const data: any = {
      comboPackageId: id,
    };
    this.routing.goToComboPackage(data);
  }

  goToDetailComboBooking(id: string) {
    const data: any = {
      comboBookingId: id,
    };
    this.routing.goToDetailComboBooking(data);
  }
}
